import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/experience")({
  component: Experience,
});

// Ported from design-reference/experience.html's `.entry` / `.entry-head`
// pattern.
function Experience() {
  return (
    <>
      <p className="frame-label">
        frame <b>#3</b> — experience()
      </p>
      <div className="sec-head">
        <span className="addr">0x0003</span>
        <h2>experience[]</h2>
      </div>

      <div className="entry">
        <div className="entry-head">
          <span>Accenture — Software Engineering Intern</span>
          <span className="when">May 2026 – Jul 2026</span>
        </div>
        <div className="listing">
          <div className="line active">
            <span className="addr">call</span>
            <span>
              Redesigned a single-step LLM generation pipeline into a 3-stage multi-agent workflow
              (analysis, generation, validation), orchestrated with LangGraph.
            </span>
          </div>
          <div className="line active">
            <span className="addr">call</span>
            <span>
              Decomposed a monolithic generation step into staged, independently verifiable tasks
              using Object-Oriented Design principles.
            </span>
          </div>
          <div className="line active">
            <span className="addr">call</span>
            <span>
              Deployed pipeline stages as asynchronous Celery workers backed by RabbitMQ and Redis
              for fault-isolated, scalable execution.
            </span>
          </div>
          <div className="line active">
            <span className="addr">ret</span>
            <span>Reduced output size by up to 60% on very large outputs.</span>
          </div>
        </div>
        <div className="tags">
          <span className="tag">LangGraph</span>
          <span className="tag">Celery</span>
          <span className="tag">RabbitMQ</span>
          <span className="tag">Redis</span>
          <span className="tag">OOD</span>
        </div>
      </div>

      <Link to="/blog" className="cta primary">
        step into blog()
      </Link>
      <Link to="/resume" className="cta">
        view full resume
      </Link>
    </>
  );
}
